import { authSlice } from 'features/auth/authSlice';
import { errorHandlingSlice } from 'features/errorHandling/errorHandlingSlice';
import { filtersWorkOrderSlice } from 'features/filtersWorkOrder/filtersWorkOrderSlice';
import { collapseStateSlice } from 'features/memoizedValues/collapseStateSlice';
import { memoizedValuesSlice } from 'features/memoizedValues/memoizedValuesSlice';
import { notificationsSlice } from 'features/notifications/notificationsSlice';
import { pinSlice } from 'features/pin/pinSlice';
import { requestSlice } from 'features/request/requestSlice';
import { selectionSlice } from 'features/selection/selectionSlice';
import { createMultiReducer } from 'utils/createMultiReducer';
import { errors } from 'utils/ErrorHandler';

import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { rootSaga } from './sagas';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        [authSlice.name]: authSlice.reducer,
        [requestSlice.name]: requestSlice.reducer,
        // @ts-ignore
        requests: createMultiReducer(requestSlice.reducer),
        // @ts-ignore
        selections: createMultiReducer(selectionSlice.reducer),
        // @ts-ignore
        pins: createMultiReducer(pinSlice.reducer),
        // @ts-ignore
        [notificationsSlice.name]: notificationsSlice.reducer,
        filtersWorkOrder: filtersWorkOrderSlice.reducer,
        errorHandling: errorHandlingSlice.reducer,
        [memoizedValuesSlice.name]: memoizedValuesSlice.reducer,
        [collapseStateSlice.name]: collapseStateSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['request/makeRequest'],
                ignoredActionPaths: ['payload.actions.0.onClick'],
                ignoredPaths: ['notifications.items.0.actions.0.onClick'],
            },
        }),
        sagaMiddleware,
        errors,
    ],
});

sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
